import { Text, TextStyle } from "pixi.js";
import { Event } from "event-system";

export class TextWithTime extends Text {
    protected static readonly MILLISECONDS_ON_SECOND = 1000;
    protected static readonly SECONDS_ON_MINUTE = 60;
    protected static readonly SECONDS_ON_HOURS = 3600;

    public readonly onComplete: Event<void>;

    protected milliseconds: number;

    private defaultTextValue: string;
    private completeTimeText: string;

    private state: TextWithTimeState;

    public get currentState(): TextWithTimeState {
        return this.state;
    }

    public get defaultText(): string {
        return this.defaultTextValue;
    }

    public constructor(milliseconds: number, defaultText: string, completeTimeText?: string, style?: TextStyle) {
        super(defaultText, style);
        this.onComplete = new Event<void>();
        this.defaultTextValue = defaultText;
        this.completeTimeText = completeTimeText;
        this.milliseconds = milliseconds;
        this.state = milliseconds > 0 ? TextWithTimeState.IN_PROGRESS : TextWithTimeState.COMPLETED;
    }

    public updateTime(timeMs: number): void {
        if (timeMs > 0) {
            this.state = TextWithTimeState.IN_PROGRESS;
            this.milliseconds = timeMs;
            this.text = this.formatText();
        } else {
            this.state = TextWithTimeState.COMPLETED;
            this.text = this.completeTimeText;
            this.onComplete.emit();
        }
    }

    public updateDefaultText(newDefaultText: string): void {
        this.defaultTextValue = newDefaultText;
    }

    public updateCompleteTimeText(newCompleteTimeText: string): void {
        this.completeTimeText = newCompleteTimeText;
    }

    protected formatText(): string {
        const seconds = Math.floor(this.milliseconds / TextWithTime.MILLISECONDS_ON_SECOND);
        const hours = Math.floor(seconds / TextWithTime.SECONDS_ON_HOURS);
        const minutes = Math.floor((seconds - hours * TextWithTime.SECONDS_ON_HOURS) / TextWithTime.SECONDS_ON_MINUTE);
        const remainingSeconds = seconds % TextWithTime.SECONDS_ON_MINUTE;
        return `${this.defaultTextValue}${hours > 0 ? hours.toString().padStart(2, '0') + ":" : ""}${minutes.toString().padStart(2, '0')}:${remainingSeconds.toString().padStart(2, '0')}`;
    }
}

export enum TextWithTimeState {
    IN_PROGRESS,
    COMPLETED
}